import { css } from '@emotion/react';
import { useEffect } from 'react';
import { ColorPicker as ReactColorPalettePicker, ColorService, useColor } from 'react-color-palette';
import tinycolor from 'tinycolor2';
import { su, theme } from '@arc/frontend/ui-theme';
import { ReactColorPaletteStyles } from './react-color-palette-styles';
export function ColorPicker({
  disableAlpha = true,
  onChange,
  color: colorProp
}) {
  const [colorState, setColorState] = useColor(colorProp ?? '');
  useEffect(() => {
    if (colorProp && colorState.hex !== colorProp) {
      setColorState(ColorService.convert('hex', colorProp));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorProp]);
  return <div css={[ReactColorPaletteStyles, {
    '& .rcp': {
      background: theme.colors.background.paper,
      borderRadius: 0
    },
    '& .rcp-saturation': {
      borderRadius: 0
    },
    '& .rcp-field-input': {
      borderRadius: 2,
      border: '1px solid',
      borderColor: theme.colors.input.border,
      color: theme.colors.text.primary,
      '&:focus-within': /*#__PURE__*/css(su.shadow, {
        borderColor: theme.colors.input.focusedBorder
      }, process.env.NODE_ENV === "production" ? "" : ";label:--focus-within;")
    },
    '& .rcp-body': {
      paddingTop: '10px',
      paddingBottom: '5px'
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:ColorPicker;"]}>
			<ReactColorPalettePicker color={colorState} hideAlpha={disableAlpha} hideInput={['hsv', 'rgb']} onChange={setColorState} onChangeComplete={color => {
      setColorState(color);
      const parsedColor = tinycolor(color.hex);
      onChange(disableAlpha ? parsedColor.toHexString() : parsedColor.toHex8String());
    }} />
		</div>;
}